import React, { useState, useEffect } from "react";
import {
  Box,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Button,
  HStack,
  Text,
  Input,
  InputGroup,
  InputLeftElement,
  Spacer,
  Select,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalCloseButton,
  ModalFooter,
  useDisclosure,
  ModalBody,
  Progress,
  useBreakpointValue // Import useBreakpointValue
} from "@chakra-ui/react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { css } from "@emotion/react";
import { fetchJobs, setCurrentPage, setStatusFilter, setFromDate, setToDate } from '../../store/slices/jobManagementSlice'; // Import actions
import { useSelector, useDispatch } from "react-redux"; // Ensure these are imported
import { ViewIcon, ArrowBackIcon, ArrowForwardIcon } from "@chakra-ui/icons"; // Add this import statement



import axios from 'axios'; // Import Axios
import ViewJob from './viewJob';

const JobManagementTable = ({ onViewJob }) => {
  const dispatch = useDispatch();
  const { jobs, totalPages, currentPage, statusFilter, fromDate, toDate } = useSelector((state) => state.jobManagement); // Access state

  // const [totalPages, setTotalPages] = useState(1);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [searchTerm, setSearchTerm] = useState(""); // Define searchTerm if it's used

  const itemsPerPage = 6;

  const inputSize = useBreakpointValue({ base: "sm", md: "md" }); // Define responsive input size
  const paginationButtonSize = useBreakpointValue({ base: "xs", md: "sm" }); // Define responsive button size
  const paginationSpacing = useBreakpointValue({ base: 2, md: 4 }); // Define responsive spacing
  const statusFilterWidth = useBreakpointValue({ base: "150px", md: "120px" }); // Define responsive width for the status filter
  const datePickerWidth = useBreakpointValue({ base: "110px", md: "140px" }); // Define responsive width for DatePicker

  // Fetch jobs from the API
  useEffect(() => {
    dispatch(fetchJobs({ currentPage, itemsPerPage: 7, statusFilter, fromDate, toDate })); // Dispatch fetchJobs action
  }, [dispatch, currentPage, statusFilter, fromDate, toDate]);

// Calculate the vacancy progress percentage
const getVacancyProgress = (vacancies, hiredCount) => (hiredCount / vacancies) * 100;

  const handlePageChange = (newPage) => {
    dispatch(setCurrentPage(newPage)); // Dispatch setCurrentPage action
  };

  const handleStatusFilterChange = (e) => {
    dispatch(setStatusFilter(e.target.value.toLowerCase())); // Convert to lowercase
  };

  const handleFromDateChange = (date) => {
    dispatch(setFromDate(date)); // Dispatch setFromDate action
  };

  const handleToDateChange = (date) => {
    dispatch(setToDate(date)); // Dispatch setToDate action
  };

  // Sort jobs by postedAt in descending order
const sortedJobs = [...jobs].sort((a, b) => new Date(b.postedAt) - new Date(a.postedAt));


  // Filter jobs based on search term and filters
  const filteredJobs = sortedJobs.filter(job => {
    const matchesSearchTerm = job.jobTitle.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesStatus = statusFilter === "" || job.status.toLowerCase() === statusFilter;

    // Convert job's posted date to Date object
    const postedDate = new Date(job.postedAt);
    
    // Convert filter dates to Date objects
    const fromDateObj = fromDate ? new Date(fromDate) : null;
    const toDateObj = toDate ? new Date(toDate) : null;

    // // Debug logs
    // console.log('Filtering job:', {
    //   jobTitle: job.jobTitle,
    //   postedDate: postedDate,
    //   fromDate: fromDateObj,
    //   toDate: toDateObj
    // });

    // Check if the job's posted date falls within the selected range
    const matchesDateRange = (!fromDateObj || postedDate >= fromDateObj) && 
                           (!toDateObj || postedDate <= toDateObj);

    console.log('Date range match:', matchesDateRange);

    return matchesSearchTerm && matchesStatus && matchesDateRange;
  });

  // const totalPages = Math.ceil(filteredJobs.length / itemsPerPage);
  const currentJobs = filteredJobs.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);


  const handleViewJob = (jobId) => {
    onViewJob(jobId); // Set the selected job in ProviderHome
  };

  const getStatusBadge = (status,isFullyHired) => {
    if (isFullyHired) {
      return (
        <HStack>
          <Text color="green.400">Recruited</Text>
        </HStack>
      );
    }
    console.log(status);
    switch (status) {
      case "hired":
        return (
          <HStack>
            {/* <Box as="span" bg="green.400" borderRadius="50%" boxSize={2} />/ */}
            <Text  color="green.400">Recruited</Text>
          </HStack>
        );
      case "pending":
        return (
          <HStack>
            {/* <Box as="span" bg="red.400" borderRadius="50%" boxSize={2} /> */}
            <Text  color="orange.400">Listed</Text>
          </HStack>
        );
        case "backup":
        return (
          <HStack>
            {/* <Box as="span" bg="red.400" borderRadius="50%" boxSize={2} /> */}
            <Text  color="gray.400">Backup</Text>
          </HStack>
        );
        case "cancelled":
        return (
          <HStack>
            {/* <Box as="span" bg="red.400" borderRadius="50%" boxSize={2} /> */}
            <Text  color="red.400">Cancelled</Text>
          </HStack>
        );
      default:
        return (
          <HStack>
            {/* <Box as="span" bg="red.400" borderRadius="50%" boxSize={2} /> */}
            <Text color="red.400">Pending</Text>
          </HStack>
        );
    }
  };
  const customStyles = css`
  .react-datepicker {
    background-color: white;
    border-radius: 8px;
    box-shadow: 0 0 0 1px #F7FAFC; /* gray.50 */
  }
  .react-datepicker__header {
    background-color: white;
    border-bottom: 1px solid #cbd5e0; /* gray.300 */
  }
  .react-datepicker__day--selected {
    background-color: #3182ce; /* blue.500 */
    color: white;
  }
  .react-datepicker__day--keyboard-selected {
    background-color: #3182ce; /* blue.500 */
    color: white;
  }
  .react-datepicker__day:hover {
    background-color: #bee3f8; /* blue.100 */
  }
  .react-datepicker__current-month,
  .react-datepicker__day-name {
    color: #2b6cb0; /* blue.600 */
  }
  .react-datepicker__navigation--previous,
  .react-datepicker__navigation--next {
    border-color: #2b6cb0; /* blue.600 */
  }
  .react-datepicker__day--outside-month {
    color: #e53e3e; /* red.500 */
  }
  .react-datepicker__day--weekend {
    color: #e53e3e; /* red.500 */
  }
  .react-datepicker__day {
    border-radius: 50%;
  }
  .react-datepicker__day--today {
    border: 1px solid #3182ce; /* blue.500 */
  }
    .react-datepicker__clear-button {
      display: block;
      margin: 0.5rem auto;
      background-color: #e2e8f0;
      border: none;
      border-radius: 4px;
      padding: 0.3rem 0.6rem;
      cursor: pointer;
    }
`;

  const handleDeleteJob = async (jobId) => {
    try {
      await axios.post('/api/delete-job', { jobId });
      // Fetch updated job list
      dispatch(fetchJobs({ currentPage, itemsPerPage, statusFilter, fromDate, toDate }));
    } catch (error) {
      console.error('Error deleting job:', error);
    }
  };

  return (
    <Box w="100%" p={1}  display="flex" flexDirection="column" minH="90vh">
      {/* Search, Filter, and Sort Section */}
        <HStack ml={10} mb={4} spacing={4} flexWrap="nowrap" alignItems="center" justifyContent="space-between">

        <Spacer />
        
        <Select
          value={statusFilter}
          onChange={handleStatusFilterChange}
          maxW="120px"
          border="1px solid"
          borderColor="gray.300"
          bg="white"
          borderRadius={5}
          textAlign="center"
          h={inputSize === "sm" ? "30px" : "40px"} // Adjust height based on screen size
          w={statusFilterWidth} // Use responsive width
          boxShadow="md"
        >
          <option value="">All</option>
          <option value="hired">Recruited</option>
          <option value="pending">Listed</option>
        </Select>
        <DatePicker

          selected={fromDate}
          onChange={handleFromDateChange}
          customInput={<Input placeholder="dd/mm/yyyy" size={inputSize} width={datePickerWidth} />}
          dateFormat="dd/MM/yyyy"
          placeholderText="From"
          

          isClearable

          
        />
        
        <DatePicker
          selected={toDate}
          onChange={handleToDateChange}
          customInput={<Input placeholder="dd/mm/yyyy" size={inputSize} width={datePickerWidth} />}
          dateFormat="dd/MM/yyyy"
          placeholderText="To"
          popperPlacement="bottom-end" // Adjust the placement to ensure visibility

          isClearable

        />
      </HStack>

      {/* Job Management Table */}
      <Box flexGrow={1} overflowY="auto">
      {jobs.length === 0 ? (
        <Text textAlign="center" mt={60} color="gray.500" fontSize="md">
          There are no jobs found.
        </Text>
    ) : (
        <Table variant="simple" colorScheme="gray" w="100%">
          <Thead bg="gray.100">
            <Tr>
              <Th px={6} py={4} textAlign="left">Job Title</Th>
              <Th px={6} py={4} textAlign="left">Status</Th>
              <Th px={6} py={4} textAlign="left">Vacancies</Th>
              <Th px={6} py={4} textAlign="left">Posted Date</Th>
              <Th px={6} py={4} textAlign="left">Applied</Th>
              <Th px={6} py={4} textAlign="left">Actions</Th>
            </Tr>
          </Thead>
          <Tbody>
          {filteredJobs.map((job, index) => {
             const vacancyProgress = getVacancyProgress(job.vacancies, job.hiredCandidates.length);
             const isFullyHired = job.hiredCandidates.length === job.vacancies;
           console.log(`Job ${index}:`, job); // Log each job object to the console
            return (
                <Tr key={index} _hover={{ transform: 'translateY(-5px)', boxShadow: 'lg', transition: 'transform 0.2s ease-in-out', bg: '#F5F6F8' }}>
                <Td px={6} py={4} textAlign="left">{job.jobTitle}</Td>
                <Td px={6} py={4} textAlign="left">{getStatusBadge(job.status,isFullyHired)}</Td>
                <Td px={6} py={4} textAlign="left"><Progress value={vacancyProgress} colorScheme={isFullyHired ? "green" : "blue"} size="sm" borderRadius="md" />
                      <Text mt={1} fontSize="sm" color={isFullyHired ? "green.500" : "gray.500"}>
                        {isFullyHired ? "Filled" : `${job.hiredCandidates.length}/${job.vacancies} Filled`}
                      </Text></Td>
                <Td px={6} py={4} textAlign="left">{new Date(job.postedAt).toLocaleDateString()}</Td>
                <Td px={6} py={4} textAlign="left">{job.appliedCandidates.length}</Td>
                <Td px={6} py={4} textAlign="left">
                  <HStack justifyContent="flex-start" alignItems="center" spacing={2}>
                    <Button size="sm" leftIcon={<ViewIcon color="blue.400" />} bg="transparent" _hover={{ bg: "transparent" }} onClick={() => handleViewJob(job._id)}>
                </Button>
          </HStack>
        </Td>
      </Tr>
    );
  })}
</Tbody>
        </Table>
        )}
      </Box>

      {/* Pagination Component */}
      <HStack spacing={paginationSpacing} mt={6} justifyContent="center" flexWrap="wrap">
      <Button variant="ghost" 
      isDisabled={currentPage === 1}
       onClick={() => handlePageChange(currentPage - 1)} 
       color="gray.700"     
       size={paginationButtonSize} // Adjust button size
      >
        <ArrowBackIcon />
    </Button>
    {Array.from({ length: totalPages }, (_, i) => (
        <Button key={i + 1} 
        colorScheme={currentPage === i + 1 ? 'gray' : 'gray'}
         bg={currentPage === i + 1 ? 'gray.500' : 'gray.200'} 
         color={currentPage === i + 1 ? 'white' : 'black'} 
         onClick={() => handlePageChange(i + 1)} 
         borderRadius="md" 
         width={paginationButtonSize === "xs" ? "30px" : "40px"} // Adjust width based on button size
      size={paginationButtonSize} // Adjust button size
      >
            {i + 1}
        </Button>
    ))}
    <Button variant="ghost" 
    isDisabled={currentPage === totalPages} 
    onClick={() => handlePageChange(currentPage + 1)}
     color="gray.700"
     size={paginationButtonSize} // Adjust button size

     >
        <ArrowForwardIcon />
    </Button>
  </HStack>

      {/* Popup Modal */}
      <Modal isOpen={isOpen} onClose={onClose} size="xl" width="50%">
        <ModalOverlay backdropFilter="blur(10px)" />
        <ModalContent>
          <ModalCloseButton />
          <ModalBody>
            <ViewJob />
          </ModalBody>
          <ModalFooter>
            <Button colorScheme="blue" mr={3} onClick={onClose}>
              Close
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </Box>
  );
};

export default JobManagementTable;
